import axiosInstance from '../../../config/axiosInstance';
import type {
  PVReserve,
  PVReserveWrite,
  PVReservePaymentWrite,
} from '../types/projectVitalReserves';

const base = '/project-vital/finance/reserves';

export async function listPVReserves(): Promise<PVReserve[]> {
  const { data } = await axiosInstance.get<PVReserve[]>(base);
  return data;
}

export async function createPVReserve(payload: PVReserveWrite): Promise<PVReserve> {
  const { data } = await axiosInstance.post<PVReserve>(base, payload);
  return data;
}

export async function updatePVReserve(id: string, payload: PVReserveWrite): Promise<PVReserve> {
  const { data } = await axiosInstance.put<PVReserve>(`${base}/${id}`, payload);
  return data;
}

export async function cancelPVReserve(id: string): Promise<PVReserve> {
  const { data } = await axiosInstance.post<PVReserve>(`${base}/${id}/cancel`);
  return data;
}

export async function payPVReserve(id: string, payload: PVReservePaymentWrite): Promise<PVReserve> {
  const { data } = await axiosInstance.post<PVReserve>(`${base}/${id}/pay`, payload);
  return data;
}
